import { render, staticRenderFns } from "./ListWarna.vue?vue&type=template&id=2a305a8c&"
import script from "./ListWarna.vue?vue&type=script&lang=js&"
export * from "./ListWarna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports